import React from 'react';
import classNames from 'classnames';

import {
  Container,
  Text,
} from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ButtonWrapper, Slider, VariableRatiosPicture } from '../../../components';
import type { ParagraphTextImageGrid as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphTextImageGridProps {
  id?: string;
  entity: ImmutableEntity<Type>;
  noBootstrap?: boolean;
}

const ParagraphTextImageGrid: React.FC<ParagraphTextImageGridProps> = ({
  id,
  entity,
  noBootstrap = false,
}) => {
  const paragraphTextImageGrid = entity.toJS();

  const title = paragraphTextImageGrid.field_title[0]?.value;
  const body = paragraphTextImageGrid.field_body[0]?.processed || '';
  const images = paragraphTextImageGrid.field_media_items;

  const link = paragraphTextImageGrid.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;
  const secondaryLink = paragraphTextImageGrid.field_link_secondary[0];
  const secondaryLinkTitle = secondaryLink?.title;
  const secondaryLinkUrl = secondaryLink?.alias || secondaryLink?.uri;

  const classes = classNames('Paragraph', 'ParagraphTextImageGrid', {
    ParagraphTextImageGrid__noBootstrap: noBootstrap,
  });

  return (
    <div id={id} className={classes}>
      <Container>
        <div className={noBootstrap ? 'noBootstrapRow' : 'row'}>
          <div className={noBootstrap ? 'noBootstrapColumn' : 'col-12 col-md-10 col-lg-8'}>
            {(title || body || linkUrl || secondaryLinkUrl) && (
              <div className="ParagraphTextImageGrid__body">
                <Text
                  title={title}
                  text={body}
                />

                {(linkUrl || secondaryLinkUrl) && (
                  <div className="ParagraphTextImageGrid__links">
                    {linkUrl && (
                      <ButtonWrapper
                        type="secondary"
                        href={linkUrl}
                      >
                        {linkTitle}
                      </ButtonWrapper>
                    )}

                    {secondaryLinkUrl && (
                      <ButtonWrapper
                        type="textual"
                        href={secondaryLinkUrl}
                      >
                        {secondaryLinkTitle}
                      </ButtonWrapper>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-full col-lg-12">
            <div className="ParagraphTextImageGrid__slider-wrapper">
              <Slider noBootstrap={noBootstrap}>
                {images.map((image) => (
                  <VariableRatiosPicture
                    image={image}
                    aspectRatios={['4_3', '4_3', '16_9', '2_1', '16_9']}
                    cropSizes={['sm', 'md', 'lg', 'lg', 'lg']}
                  />
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </Container>

    </div>
  );
};

export default ParagraphTextImageGrid;
